// ============================
// Auth Token Keys
// Separate storage per app to
// prevent token contamination
// ============================

export const STOREFRONT_TOKEN_KEY = "ph_buyer_access_token";
export const STOREFRONT_REFRESH_KEY = "ph_buyer_refresh_token";

export const SELLER_TOKEN_KEY = "ph_seller_access_token";
export const SELLER_REFRESH_KEY = "ph_seller_refresh_token";

export const ADMIN_TOKEN_KEY = "ph_admin_access_token";
export const ADMIN_REFRESH_KEY = "ph_admin_refresh_token";

export const VEHICLE_STORAGE_KEY = "ph_saved_vehicles";
export const CART_STORAGE_KEY = "ph_cart";
